<template>
    <page :busy="busy" :tabs="tabs" class="account-details-page">
        <div v-if="accountData.client.user.id">
            <div>
                <h5 class="pt-3">
                    Login and
                    {{ accountData.is_subscriber ? 'Billing' : '' }}
                    Notification Email
                </h5>
                <hr />
            </div>
            <b-row class="flex-column flex-md-row w-100">
                <b-col>
                    <form-input
                        :leftIcon="['fas', 'at']"
                        floatingLabel="Email"
                        :disabled="true"
                        v-model="email"
                        :error="formErrors['client.user.email']"
                    ></form-input>
                </b-col>
                <b-col class="pr-md-0">
                    <form-input
                        floatingLabel="Email CC"
                        :leftIcon="['fas', 'at']"
                        :error="formErrors['client.user.email_cc']"
                        @input="onChangeEmail"
                        v-model="email_cc"
                    ></form-input>
                </b-col>
            </b-row>
            <div v-if="!accountData.deny_edit_profile">
                <div>
                    <h5 class="pt-2">
                        {{ formSubTitle }}
                        Information
                    </h5>
                    <hr />
                </div>
                <b-row class="flex-column flex-md-row w-100">
                    <b-col>
                        <div class="d-flex flex-column flex-md-row">
                            <form-select
                                floatingLabel="Title"
                                class="w-100 mr-3"
                                :options="prefixOptions"
                                :leftIcon="['fas', 'user']"
                                v-model="selectedPrefix"
                            ></form-select>

                            <form-input
                                floatingLabel="First Name"
                                :leftIcon="['fas', 'user']"
                                :error="formErrors['client.first_name']"
                                v-model="first_name"
                            />
                        </div>
                        <form-input
                            floatingLabel="Address 1"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="accountData.client.address.address1"
                        ></form-input>
                        <div class="d-flex flex-column flex-md-row">
                            <form-select
                                v-model="selectedCountry"
                                floatingLabel="Country"
                                class="w-100 mr-3"
                                :options="countriesOptions"
                                @change="onChangeCountry"
                                :leftIcon="['fas', 'location-dot']"
                            ></form-select>
                            <form-input
                                class="w-100"
                                floatingLabel="Zip"
                                :leftIcon="['fas', 'location-dot']"
                                v-model="accountData.client.address.zip"
                                @input="autoFillCity"
                            ></form-input>
                        </div>
                        <form-input
                            floatingLabel="City"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="accountData.client.address.city"
                        ></form-input>
                        <form-phone-number-input
                            inputId="billing-phone"
                            floating-label="Phone"
                            v-model="accountData.client.address.phone"
                            :default-country-code="defaultCountryCode"
                            @input="onChangePhone"
                            @validate="onValidatePhone"
                            :error="isPhoneInvalid ? 'Incorrect phone number' : ''"
                        ></form-phone-number-input>
                    </b-col>
                    <b-col class="pr-md-0">
                        <form-input
                            :leftIcon="['fas', 'user']"
                            floatingLabel="Last Name"
                            :error="formErrors['client.last_name']"
                            v-model="last_name"
                        ></form-input>
                        <form-input
                            floatingLabel="Address 2"
                            :leftIcon="['fas', 'location-dot']"
                            v-model="accountData.client.address.address2"
                        ></form-input>
                        <span class="form-tip">Your city and state will be automatically added</span>
                        <form-select
                            :leftIcon="['fas', 'location-dot']"
                            v-model="selectedState"
                            :options="statesOptions"
                            floatingLabel="State"
                        ></form-select>
                        <form-input
                            v-model="company"
                            :error="formErrors['client.company']"
                            floatingLabel="Company"
                            :leftIcon="['fas', 'building']"
                        ></form-input>
                    </b-col>
                </b-row>
            </div>
            <div v-if="false">
                <h5 class="pt-3">SMS Notifications</h5>
                <hr />
            </div>
            <b-row class="w-100">
                <b-col>
                    <div class="d-flex flex-column flex-md-row align-items-center">
                        <form-phone-number-input
                            label="SMS Phone:"
                            inputId="sms-phone"
                            v-model="accountData.client.sms_phone"
                            :default-country-code="defaultSmsCountryCode"
                            :error="!isSmsValid && accountData.client.sms_phone ? 'Incorrect phone number' : ''"
                            :disabled="accountData.client.sms_validated"
                            @input="onChangeSmsPhone"
                            @validate="onValidateSmsPhone"
                        ></form-phone-number-input>
                        <b-button
                            class="d-none d-md-block w-50 ml-md-2"
                            :class="{
                                'verify-button': !isSmsValid && accountData.client.sms_phone,
                                ' mt-md-3': isSmsValid || !accountData.client.sms_phone,
                            }"
                            variant="primary"
                            @click="clearOrVerifySMSPhone"
                            :disabled="!isSmsValid"
                        >
                            {{ accountData.client.sms_validated ? 'Clear Phone' : 'Verify Phone' }}
                        </b-button>
                        <b-button
                            class="d-block d-md-none w-100 ml-md-2 mt-md-3"
                            variant="primary"
                            @click="clearOrVerifySMSPhone"
                            :disabled="!isSmsValid"
                        >
                            {{ accountData.client.sms_validated ? 'Clear Phone' : 'Verify Phone' }}
                        </b-button>
                    </div>
                    <form-checkbox
                        v-if="accountData.client.user.allow_automatic_sms_alerts && false"
                        :value="accountData.client.automatic_sms_alerts"
                        @change="setAutoSmsAlerts"
                        class="w-100 mt-4 mt-md-0"
                    >
                        Receive automatic SMS alerts from Lodgix
                    </form-checkbox>
                </b-col>
                <b-col class="d-none d-md-block"></b-col>
            </b-row>
            <div>
                <h5 class="pt-2">Change Password</h5>
                <hr />
            </div>
            <b-row class="flex-column flex-md-row w-100">
                <b-col>
                    <form-input
                        autocomplete="new-password"
                        v-model="password"
                        floatingLabel="New Password"
                        :leftIcon="['fas', 'lock']"
                        :error="formErrors['client.user.password']"
                        type="password"
                    ></form-input>
                    <b-button
                        class="d-none d-md-flex"
                        variant="primary"
                        @click="saveAccountDetails"
                        :disabled="!meta.valid || isPhoneInvalid"
                    >
                        Save
                    </b-button>
                </b-col>
                <b-col class="pr-md-0">
                    <form-input
                        autocomplete="new-password"
                        v-model="confirm_password"
                        floatingLabel="Confirm New Password"
                        :leftIcon="['fas', 'lock']"
                        :error="formErrors['client.user.confirm_password']"
                        type="password"
                    ></form-input>
                    <b-button
                        variant="primary"
                        @click="saveAccountDetails"
                        :disabled="!meta.valid || isPhoneInvalid"
                        class="d-flex d-md-none mb-2"
                    >
                        Save
                    </b-button>
                </b-col>
            </b-row>
            <modal
                id="verify-phone-modal"
                @hidden="verifyCode = null"
                @ok.prevent="verifyPhoneNumber"
                title="Verify SMS Phone"
                ok-title="Verify"
            >
                <form-input
                    v-model="verifyCode"
                    label="You should receive a code shortly. Please enter the received code:"
                ></form-input>
            </modal>
        </div>
    </page>
</template>

<script>
    import { defineAsyncComponent, onMounted, computed, ref } from 'vue';
    import API from '../../api';
    import {
        ACCOUNT_DETAILS_DATA_ENDPOINT,
        ACCOUNT_DETAILS_STATES_ENDPOINT,
        ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT,
        ACCOUNT_VALIDATE_SMS_ENDPOINT,
        ACCOUNT_DETAILS_SET_ALERTS_ENDPOINT,
        ACCOUNT_DETAILS_CLEAR_SMS_PHONE_ENDPOINT,
        ACCOUNT_GET_VERIFY_CODE_ENDPOINT,
        ACCOUNT_DETAILS_SAVE_ENDPOINT,
    } from '../../endpoints';
    import debounce from 'lodash/debounce';
    import FormCheckbox from '../generic/form-checkbox/form-checkbox.vue';
    import FormInput from '../generic/form-input/form-input.vue';
    import FormSelect from '../generic/form-select/form-select.vue';
    import { formatResponseError } from '../../utils/api';
    import page from '../generic/page/page.vue';
    import { parsePhoneNumber as PhoneNumber } from 'awesome-phonenumber';
    import Modal from '../generic/modal/modal.vue';
    import isEmpty from 'lodash/isEmpty';
    import { useStore } from 'vuex';
    import { useForm } from 'vee-validate';
    import { useToast } from '../../hooks/useToast';
    import { useModal } from '../../hooks/useModal';
    import { useScrollLock } from '../../hooks/useScrollLock';

    const FormPhoneNumberInput = defineAsyncComponent(() =>
        import(
            /* webpackChunkName: "lx-form-phone-number-input" */
            '../generic/form-phone-number-input/form-phone-number-input.vue'
        )
    );

    export default {
        components: {
            page,
            FormInput,
            FormSelect,
            FormPhoneNumberInput,
            FormCheckbox,
            Modal,
        },
        setup() {
            useScrollLock();
            // data
            const $store = useStore();
            const schema = {
                'client.user.email': 'email|required',
                'client.user.email_cc': 'email',
                'client.user.password': 'validAccountPassword',
                'client.user.confirm_password': 'confirmed:@client.user.password',
                'client.first_name': 'required',
                'client.last_name': 'required',
                'client.company': 'maxMessageLen:50',
            };

            const accountData = ref({
                client: {
                    address: {
                        address1: null,
                        address2: null,
                        city: null,
                        country: {
                            id: null,
                            name: null,
                            code: null,
                        },
                        zip: null,
                        phone: '',
                        state: {
                            code: null,
                            id: null,
                            name: null,
                        },
                    },
                    email: null,
                    automatic_sms_alerts: null,
                    company: null,
                    first_name: null,
                    last_name: null,
                    id: null,
                    sms_phone: '',
                    sms_validated: null,
                    title: { id: null, name: null },
                    user: {
                        allow_automatic_sms_alerts: null,
                        email: null,
                        email_cc: null,
                        password: null,
                        confirm_password: null,
                    },
                },
            });
            const {
                errors: formErrors,
                setValues,
                defineField,
                meta,
                setErrors,
            } = useForm({
                validationSchema: schema,
                initialValues: {
                    client: {
                        first_name: null,
                        last_name: null,
                        user: {
                            email: null,
                            email_cc: null,
                            password: null,
                            confirm_password: null,
                        },
                    },
                },
            });
            const [email] = defineField('client.user.email');
            const [email_cc] = defineField('client.user.email_cc');
            const [password] = defineField('client.user.password');
            const [confirm_password] = defineField('client.user.confirm_password');
            const [first_name] = defineField('client.first_name');
            const [last_name] = defineField('client.last_name');
            const [company] = defineField('client.company');
            const verifyCode = ref(null);
            const busy = ref(null);
            const selectedCountry = ref(null);
            const selectedPrefix = ref([]);
            const states = ref([]);
            const selectedState = ref(null);
            const isPhoneValid = ref(null);
            const isSmsValid = ref(null);
            const { errorToast, successToast } = useToast();
            const { $bvModal } = useModal();
            const formRef = ref(null);

            // methods
            const setAutoSmsAlerts = async (value) => {
                try {
                    busy.value = true;
                    await API.put(ACCOUNT_DETAILS_SET_ALERTS_ENDPOINT(), {
                        automatic_sms_alerts: value,
                    });
                    successToast.value({
                        text: 'Automatic SMS settings sucessfully saved.',
                    });
                } catch (e) {
                    errorToast.value({ text: 'Could not update settings' });
                } finally {
                    busy.value = false;
                }
            };
            const onChangeEmail = (value) => {
                const accData = JSON.parse(JSON.stringify(accountData.value));
                if (accData.is_owner) {
                    accData.client.email = value;
                } else if (accData.is_team_member) {
                    accData.client.email = value;
                } else {
                    accData.client.user.email_cc = value;
                }
                setValues({
                    ...accData,
                });
            };
            const verifyPhoneNumber = async () => {
                try {
                    const response = await API.post(ACCOUNT_VALIDATE_SMS_ENDPOINT(), {
                        sms_code: verifyCode.value,
                        sms_phone: accountData.value.client.sms_phone,
                    });
                    if (response.data.status !== 'FAIL') {
                        $bvModal.value.hide('verify-phone-modal');
                        successToast.value({
                            text: 'SMS Phone sucessfully validated',
                        });
                        accountData.value.client.sms_validated = true;
                        setValues({
                            ...accountData.value,
                        });
                    } else {
                        errorToast.value({
                            text: response.data.errors,
                        });
                    }
                } catch (e) {
                    errorToast.value({ text: 'Invalid Code. Please try again.' });
                }
            };
            const onChangePhone = (value, isValid) => {
                isPhoneValid.value = isValid;
                accountData.value.client.address.phone = value;
            };
            const onChangeSmsPhone = (value, isValid) => {
                if (!accountData.value.sms_validated) {
                    isSmsValid.value = isValid;
                }
            };
            const onValidatePhone = (value) => {
                isPhoneValid.value = value.valid;
                if (value.valid) {
                    accountData.value.client.address.phone = value.number;
                    setValues({
                        ...accountData.value,
                    });
                }
            };
            const onValidateSmsPhone = (value) => {
                if (!accountData.value.sms_validated) {
                    isSmsValid.value = value.valid;
                    if (isSmsValid.value) {
                        accountData.value.client.sms_phone = value.number;
                        setValues({
                            ...accountData.value,
                        });
                    }
                }
            };
            const onChangeCountry = async () => {
                await fetchStates();
                selectedState.value = states.value[0].id;
                const currentCountry = countriesOptions.value.find((item) => item.value === selectedCountry.value);
                $store.dispatch('account/changeCountryCode', currentCountry.code);
            };
            const saveAccountDetails = async () => {
                const currentCountry = countriesOptions.value.find((item) => item.value === selectedCountry.value);
                const currentState = statesOptions.value.find((item) => item.value === selectedState.value);
                const currentTitle = prefixOptions.value.find((item) => item.value === selectedPrefix.value);
                try {
                    busy.value = true;
                    const userObj = {
                        email: email.value,
                        email_cc: email_cc.value,
                        password: password.value,
                        confirm_password: confirm_password.value,
                        company: company.value,
                    };
                    if (!userObj.password && !userObj.confirm_password) {
                        delete userObj.password;
                        delete userObj.confirm_password;
                    }
                    const response = await API.patch(ACCOUNT_DETAILS_SAVE_ENDPOINT(), {
                        ...accountData.value.client,
                        first_name: first_name.value,
                        last_name: last_name.value,
                        user: {
                            ...accountData.value.client.user,
                            ...userObj,
                            email_cc: email_cc.value || null,
                        },
                        address: {
                            ...accountData.value.client.address,
                            country: {
                                id: currentCountry.value,
                                name: currentCountry.text,
                                code: currentCountry.code,
                            },
                            state: {
                                id: currentState.value,
                                name: currentState.text,
                                code: currentState.code,
                            },
                        },
                        title: {
                            id: currentTitle.value,
                            name: currentTitle.text,
                        },
                        company: userObj.company,
                    });
                    if (response.data.status !== 'FAIL') {
                        await fetchAccountData();
                        successToast.value({
                            text: 'Account details successfully updated.',
                        });
                    } else {
                        errorToast.value({ text: response.data.errors[0] });
                    }
                } catch (e) {
                    const { fields, generic } = formatResponseError(e);
                    if (e.response.data.address) {
                        errorToast.value({ text: e.response.data.address.phone[0] });
                    } else {
                        errorToast.value({ text: generic || 'Could not save data' });
                    }
                    if (!generic && !isEmpty(fields)) {
                        setErrors(fields);
                    }
                } finally {
                    busy.value = false;
                }
            };

            const clearOrVerifySMSPhone = async () => {
                if (accountData.value.client.sms_validated) {
                    try {
                        busy.value = true;
                        await API.put(ACCOUNT_DETAILS_CLEAR_SMS_PHONE_ENDPOINT());
                        successToast.value({
                            text: 'SMS Phone sucessfully cleared.',
                        });
                        accountData.value.client.sms_validated = false;
                        accountData.value.client.sms_phone = '';
                        isSmsValid.value = false;
                        setValues({
                            ...accountData.value,
                        });
                    } catch (e) {
                        errorToast.value({ text: 'Could not clear SMS Phone' });
                    } finally {
                        busy.value = false;
                    }
                } else {
                    $bvModal.value.show('verify-phone-modal');
                    await API.post(ACCOUNT_GET_VERIFY_CODE_ENDPOINT(), {
                        sms_phone: accountData.value.client.sms_phone,
                    });
                }
            };

            const fetchAccountData = async () => {
                try {
                    busy.value = true;
                    const response = await API.get(ACCOUNT_DETAILS_DATA_ENDPOINT());
                    accountData.value = { ...response.data };
                    accountData.value.client.address.country = accountData.value.client.address.country || {
                        id: countriesOptions.value[0].value,
                        name: countriesOptions.value[0].text,
                        code: countriesOptions.value[0].code,
                    };
                    selectedCountry.value = accountData.value.client.address.country
                        ? accountData.value.client.address.country.id
                        : countriesOptions.value[0].value;
                    accountData.value.client.sms_phone = accountData.value.client.sms_phone || '';
                    accountData.value.client.address.phone = accountData.value.client.address.phone || '';
                    await fetchStates();
                    selectedState.value = accountData.value.client.address.state
                        ? accountData.value.client.address.state.id
                        : statesOptions.value[0].value;
                    isSmsValid.value = accountData.value.client.sms_validated;
                    accountData.value.client.title = accountData.value.client.title || {
                        id: prefixOptions.value[0].value,
                        name: prefixOptions.value[0].text,
                    };

                    selectedPrefix.value = accountData.value.client.title.id || prefixOptions.value[0].value;
                    $store.dispatch('account/changeCountryCode', accountData.value.client.address.country.code);
                    accountData.value.client.user.email_cc = accountData.value.is_owner
                        ? accountData.value.client.email
                        : accountData.value.is_team_member
                        ? accountData.value.client.email
                        : accountData.value.client.user.email_cc;
                    setValues({
                        ...accountData.value,
                    });
                } catch (e) {
                    errorToast.value({ text: 'Could not load account data' });
                } finally {
                    busy.value = false;
                }
            };
            const autoFillCity = debounce(async function (value) {
                if (value) {
                    try {
                        busy.value = true;
                        const response = await API.get(ACCOUNT_AUTOFILL_VIA_ZIP_ENDPOINT(selectedCountry.value, value));
                        if (response.data.city) {
                            accountData.value.client.address.city = response.data.city;
                            selectedState.value = statesOptions.value.find(
                                (item) => item.text === response.data.state
                            ).value;
                            setValues({
                                ...accountData.value,
                            });
                        } else {
                            errorToast.value({
                                text: 'Unable to auto fill city and state',
                            });
                        }
                    } catch (e) {
                        errorToast.value({ text: 'Could not load state and city' });
                    } finally {
                        busy.value = false;
                    }
                }
            }, 1000);
            const fetchStates = async () => {
                try {
                    busy.value = true;
                    const response = await API.get(ACCOUNT_DETAILS_STATES_ENDPOINT(selectedCountry.value));
                    states.value = response.data.states;
                } catch (e) {
                    errorToast.value({ text: 'Could not load states' });
                } finally {
                    busy.value = false;
                }
            };
            // computed
            const prefixOptions = computed(() => {
                return [
                    { value: 1, text: 'Mr.' },
                    { value: 10, text: 'Mrs.' },
                    { value: 11, text: 'Ms.' },
                    { value: 56, text: 'Mr. & Mrs' },
                    { value: 7301, text: 'Dr.' },
                ];
            });
            const countriesOptions = computed(() => {
                return (
                    accountData.value.countries &&
                    accountData.value.countries.map((item) => ({
                        ...item,
                        value: item.id,
                        text: item.name,
                    }))
                );
            });
            const statesOptions = computed(() => {
                return states.value.map((item) => ({
                    ...item,
                    value: item.id,
                    text: item.name,
                }));
            });
            const defaultCountryCode = computed(() => {
                if (accountData.value.client.address.phone) {
                    const phone = PhoneNumber(accountData.value.client.address.phone);
                    return phone.g.regionCode;
                } else {
                    return $store.getters['account/code'];
                }
            });
            const defaultSmsCountryCode = computed(() => {
                if (accountData.value.client.sms_phone) {
                    const phone = PhoneNumber(accountData.value.client.sms_phone);
                    return phone.g.regionCode;
                } else {
                    return $store.getters['account/code'];
                }
            });

            const formSubTitle = computed(() => {
                return accountData.value.is_subscriber ? 'Billing' : 'Personal';
            });


            const isPhoneInvalid = computed(() => {
                return !!accountData.value.client.address.phone && !isPhoneValid.value;
            });

            const tabs = computed(() => {
                return [
                    {
                        active: true,
                        title: 'Account',
                        route: '/app/account/details/',
                    },
                    {
                        active: false,
                        title: 'Two Step Authentification',
                        route: '/app/account/two-step/',
                    },
                ];
            });

            // hooks
            onMounted(async () => {
                await fetchAccountData();
            });

            return {
                // data
                accountData,
                verifyCode,
                busy,
                selectedCountry,
                selectedPrefix,
                states,
                selectedState,
                isPhoneInvalid,
                isSmsValid,
                // methods
                autoFillCity,
                clearOrVerifySMSPhone,
                saveAccountDetails,
                onChangeCountry,
                onChangeEmail,
                onValidatePhone,
                onChangeSmsPhone,
                onValidateSmsPhone,
                verifyPhoneNumber,
                verifyPhoneNumber,
                setAutoSmsAlerts,
                onChangePhone,
                // computed
                prefixOptions,
                countriesOptions,
                statesOptions,
                defaultCountryCode,
                defaultSmsCountryCode,
                formSubTitle,
                tabs,
                formErrors,
                // form values,
                email,
                email_cc,
                password,
                confirm_password,
                first_name,
                last_name,
                formRef,
                meta,
                company,
            };
        },
    };
</script>

<style scoped lang="scss">
    .account-details-page {
        padding: 0 15px 30px 15px;
        .verify-button {
            margin-bottom: 12px;
        }
        :deep(ul.nav) {
            margin-left: 0 !important;
            margin-bottom: 0 !important;
            .router-link-active {
                background-color: #f7f7f7 !important;
                margin-bottom: 0 !important;
                border-color: #dee2e6 #dee2e6 transparent;
            }
        }
        :deep(.lx-page-container) {
            padding: 0 0 30px 15px;
            background-color: #f7f7f7;
            border-bottom: 1px solid #ddd;
            border-left: 1px solid #ddd;
            border-radius: 0 5px 5px 5px;
            border-right: 1px solid #ddd;
            .input-wrapper .vue-tel-input .form-phone-number-input-label {
                background-color: #fff !important;
            }
        }
        .form-tip {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 1rem;
        }
    }
</style>
